import React, { useState, useEffect } from 'react';
import { IconButton, Paper, TableContainer, Table, TableHead, TableCell, TableBody, TableRow } from '@mui/material';
import { Edit } from '@mui/icons-material';
import { api } from '../../api/instance';
import Loader from '../../components/Loader/Loader';
import { useNavigate } from 'react-router-dom';

const Pages = () => {
  const [pages, setPages] = useState([]);
  const [loading, setLoading] = useState();
  const navigate = useNavigate();

  useEffect(() => {
    const getPages = async () => {
      try {
        setLoading(true);
        const response = await api.get('/pages');
        setPages(response.data.pages);
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };

    getPages();
  }, []);

  return loading ? (
    <Loader />
  ) : (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Page</TableCell>
            <TableCell>Description</TableCell>
            <TableCell>EDIT</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {pages.map((page) => (
            <TableRow key={page.title} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
              <TableCell component="th" scope="row">
                {page.title}
              </TableCell>
              <TableCell>
                {page.description
                  .replace(/<\/?("[^"]*"|'[^']*'|[^>])*(>|$)/g, '')
                  .split(' ')
                  .splice(0, 4)
                  .join(' ')}
              </TableCell>
              <TableCell>
                <IconButton color="primary" onClick={() => navigate(`/page-edit?id=${page._id}`, { state: { mode: 'edit' } })} size="large">
                  <Edit />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default Pages;
